import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const { ref, isVisible } = useScrollReveal();

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const t = testimonials[current];

  return (
    <section className="w-full py-16 md:py-24 bg-charcoal-300">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={ref}
          className={`text-center mb-10 md:mb-14 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
            Client Stories
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white">
            What Our Investors Say
          </h2>
        </div>

        <div className={`max-w-4xl mx-auto ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-2xl">
            <div className="grid grid-cols-1 md:grid-cols-[140px_1fr] gap-6 md:gap-8 items-start">
              {/* Avatar */}
              <div className="flex flex-col items-center md:items-start">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-20 h-20 md:w-28 md:h-28 rounded-2xl object-cover shadow-md"
                />
              </div>

              {/* Content */}
              <div>
                <div className="text-3xl md:text-4xl text-brand-orange font-serif leading-none mb-3 md:mb-4">&ldquo;</div>
                <p className="text-base md:text-lg text-charcoal-200 leading-relaxed mb-5">
                  {t.text}
                </p>
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(t.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-brand-orange text-sm" />
                  ))}
                </div>
                <div className="font-bold text-charcoal-300">{t.name}</div>
                <div className="text-sm text-charcoal-50">
                  {t.role} — {t.location}
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-6">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange text-white hover:text-white transition-all duration-300"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <div className="flex items-center gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                    i === current ? 'bg-brand-orange w-6' : 'bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange text-white hover:text-white transition-all duration-300"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}